import React from 'react';
import { ExternalLink } from 'lucide-react';
interface ServiceCardProps {
  title: string;
  price: string;
  features: string[];
  imageUrl: string;
  imageAlt: string;
  stripeLink: string;
}
export const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  price,
  features,
  imageUrl,
  imageAlt,
  stripeLink
}) => {
  return <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow" data-id="element-171">
      <div className="h-48 overflow-hidden" data-id="element-172">
        <img src={imageUrl} alt={imageAlt} className="w-full h-full object-cover" data-id="element-173" />
      </div>
      <div className="p-6" data-id="element-174">
        <h3 className="text-2xl font-bold text-slate-800 mb-2" data-id="element-175">{title}</h3>
        <p className="text-4xl font-bold text-blue-600 mb-4" data-id="element-176">{price}</p>
        <ul className="space-y-3 mb-6" data-id="element-177">
          {features.map((feature, index) => <li key={index} className="flex items-start space-x-2 text-slate-600" data-id="element-178">
              <span className="text-blue-600 mt-1" data-id="element-179">✓</span>
              <span data-id="element-180">{feature}</span>
            </li>)}
        </ul>
        <a href={stripeLink} target="_blank" rel="noopener noreferrer" className="w-full bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors flex items-center justify-center space-x-2 font-semibold" data-id="element-181">
          <span data-id="element-182">Pay Securely</span>
          <ExternalLink className="w-4 h-4" data-id="element-183" />
        </a>
      </div>
    </div>;
};